<template>
    <vlider
            :id="'first'"
            :vlider-data="slider"
            :theme="'theme-dark'"
            v-model="inputRange"
            @click="vliderClick"
    >
    </vlider>
</template>
<script>
    import Vlider from "vlider";

    export default {
        name: "npsSlider",
        selected : 5,
        components: {
            Vlider
        },
        data() {
            return {
                inputRange: null,
                slider: [
                    {id: 0, label: "Sehr zufrieden"},
                    {id: 1, label: ""},
                    {id: 2, label: ""},
                    {id: 3, label: ""},
                    {id: 4, label: ""},
                    {id: 5, label: ""},
                    {id: 6, label: ""},
                    {id: 7, label: ""},
                    {id: 8, label: ""},
                    {id: 9, label: "Sehr unzufrieden"}
                ]
            };
        },
        watch: {
            inputRange() {
                this.selected = this.inputRange;
                console.log(this.selected);
                console.log('inputRange');
                console.log(this.inputRange);
                console.log(this.slider[this.inputRange.label]);
            }
        },
        methods: {
            vliderClick(value) {
                console.log(`vliderClick`);
                console.log(value);
            }
        }
    };
</script>
<style scoped>

</style>
